export default "__VITE_ASSET__0bf5123e__"